import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.css']
})
export class EmployeeDetailsComponent implements OnInit {

  constructor(private productService: ServiceService, private route: ActivatedRoute, private router: Router, private formBuilder: FormBuilder) {
    this.creationForm = this.formBuilder.group({
      workin_time: [''],
      workout_time: [''],
      is_department_specific: [false],
      is_location_restricted: [false],
      weekly_working_days: [[]]
    });
  }
  creationForm: FormGroup;
  output: any = []; //---store get() result--------
  employeeId = '';
  //getUrl='http://192.241.151.66:5000/viewEmployees';
  //deptUrl='http://192.241.151.66:5000/viewDepartments';
  name = ""
  role = ""
  imgUrl = this.productService.ReturnBase();
  imgError = false;

  select_month: any
  sick_leaves: any
  vocation: any

  year = new Date();
  current_year = this.year.getFullYear()

  Month = [{ name: "January", id: "01", last: 31 },
  { name: "February", id: "02", last: 28 },
  { name: "March", id: "03", last: 31 },
  { name: "April", id: "04", last: 30 },
  { name: "May", id: "05", last: 31 },
  { name: "June", id: "06", last: 30 },
  { name: "July", id: "07", last: 31 },
  { name: "August", id: "08", last: 31 },
  { name: "September", id: "09", last: 30 },
  { name: "October", id: "10", last: 31 },
  { name: "November", id: "11", last: 30 },
  { name: "December", id: "12", last: 31 },
  ]

  //------routing to edit page--------------------
  EditEmployee() {
    this.router.navigateByUrl(('admin/edit-employee'));
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //--------function which give name of selected item---------
  getValue() {
    this.productService.setEmployeeId(this.employeeId)
  }
  //-------date formating-------------

  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe: any = null;
  DateFormat(value: any) {
    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    let myString = this.todayWithPipe
    myString = myString.substr(0, myString.length - 13);
    return myString
  }
  //-------function for year selection-----
  YearSelected(value: any) {
    this.current_year = value
    console.log("year=", this.current_year)
    var date = this.current_year + "-" + this.select_month
    console.log("date", date)
    console.log("employee id=", this.employeeId)
    this.productService.SearchEmployeeDate(this.employeeId, date).subscribe((res) => {

      if (res.data[0].leave_management_models.length != 0) {
        this.sick_leaves = res.data[0].leave_management_models[0].sick_leave_days
        this.vocation = res.data[0].leave_management_models[0].vacation_days
      }
      else {
        this.sick_leaves = []
        this.vocation = []
      }

      console.log("leave=", this.sick_leaves)

    })


  }

  MonthSelected(value: any) {

    this.select_month = this.Month[value].id
    var date = this.current_year + "-" + this.select_month
    console.log("date", date)
    console.log("employee id=", this.employeeId)
    this.productService.SearchEmployeeDate(this.employeeId, date).subscribe((res) => {

      if (res.data[0].leave_management_models.length != 0) {
        this.sick_leaves = res.data[0].leave_management_models[0].sick_leave_days
        this.vocation = res.data[0].leave_management_models[0].vacation_days
      }
      else {
        this.sick_leaves = []
        this.vocation = []
      }

      console.log("leave=", this.sick_leaves)

    })



  }
  ngOnInit(): void {
    this.genarateYearList()
    //---call function in service for employee Id------
    this.employeeId = this.productService.getEmployeeId()
    console.log("employee id=", this.employeeId)
    this.getEditdata(this.employeeId)
    //-------api get()calling-------------
    this.productService.ViewEmployeeById('/' + this.employeeId).subscribe((res) => {
      this.output = res.data
      console.log(this.output)
      console.log("last details =", res.message)
      this.name = this.output[0].employee_name
      this.role = this.output[0].role
      this.imgUrl = this.imgUrl + this.output[0].employee_document
      this.imgError = false;
    })
    this.getEmployeeTarget(this.employeeId)

  }

  weeKDays = [
    {
      week: 'Sunday',
      value: 1,
      checked: false
    },
    {
      week: 'Monday',
      value: 2,
      checked: false
    },
    {
      week: 'Tuesday',
      value: 3,
      checked: false
    },
    {
      week: 'Wednesday',
      value: 4,
      checked: false
    },
    {
      week: 'Thursday',
      value: 5,
      checked: false
    },
    {
      week: 'Friday',
      value: 6,
      checked: false
    },
    {
      week: 'Saturday',
      value: 7,
      checked: false
    },
  ];

  employeeTarget: any;
  getMonthName(yearMonth: string): string {
    const [year, month] = yearMonth.split('-').map(Number);
    // Month is 0-based in JS Date
    const date = new Date(year, month - 1);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' }); // e.g., "January 2025"
  }
  getEmployeeTarget(employee_id: string) {
    this.productService.getEmployeeTarget('?employee_id=' + employee_id + '&year=' + this.currentYear).subscribe({
      next: (value) => {
        if (value.success) {
          this.employeeTarget = value.data[0]
          // debugger
        } else {
          alert(value.message)
        }
      }, error: (err) => {
        alert(err.error.message)
      },
    })
  }
  selectedWeek: any = []
  getEditdata(id: string) {
    this.productService.ViewEmployeeById('/' + id).subscribe({
      next: (value) => {
        console.log(value);
        // debugger
        // this.employeeForm.patchValue({
        //   employee_id : value.data[0]._id 
        // })
        this.creationForm.patchValue({
          workin_time: value.data[0]?.workin_time,
          workout_time: value.data[0]?.workout_time,
          is_department_specific: value.data[0]?.is_department_specific,
          is_location_restricted: value.data[0]?.is_location_restricted,
          weekly_working_days: value.data[0]?.weekly_working_days
        });
        if (value.data[0] && 'weekly_working_days' in value.data[0]) {
          this.selectedWeek = value.data[0].weekly_working_days;
        } else {
          this.selectedWeek = [];
        }

        // this.selectedWeek = value.data[0]?.weekly_working_days
        this.creationForm.addControl(
          'employee_id',
          this.formBuilder.control(value.data[0].employee_id)
        );
        console.log(this.creationForm.value);

        let workingDays = this.creationForm.controls['weekly_working_days'].value;
        this.weeKDays.forEach(day => {
          day.checked = workingDays.includes(day.value);
        })
        console.log('working', this.weeKDays);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }



  yearList: any = [];
  currentYear = new Date().getFullYear()


  genarateYearList() {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + 2; // Add 2 years ahead
  this.yearList = [];
  for (let i = endYear; i >= 2000; i--) {
    this.yearList.push({ year: i });
  }
  console.log('yearList: ', this.yearList);
}



}
